import { Component } from 'preact'

class documentClick extends Component {
  constructor () {
    super()
    this.onClick = this.onClick.bind(this)
  }

  componentDidMount () {
    setTimeout(() => window.document.addEventListener('click', this.onClick))
  }

  componentWillUnmount () {
    window.document.removeEventListener('click', this.onClick)
  }

  onClick (e) {
    this.props.onGlobalClick(e)
  }

  render (props) {
    const Component = props.Component || 'div'
    return <Component onClick={e => {
      e.stopPropagation()
      if (props.onChildrenClick && typeof props.onChildrenClick === 'function' && e.srcElement.tagName !== 'INPUT') {
        props.onChildrenClick()
      }
    }} {...props} />
  }
}

export default documentClick
